import * as React from 'react';
import { Button, ButtonGroup, Card, Col, Row, Input, notify, Loading, Page } from 'sha-el-design';
import {
  AssignWorkMutationInput,
  StateNode,
  TownNode,
  AreaNode,
  UserDetailNode,
  StateNodeEdge,
  UserDetailNodeEdge,
  AssignWorkMutationPayload,
} from '../../../schema';
import { currentView } from './constant';
import { StateEmployeeSelection } from './StateEmployeeSelection';
import { Review } from './Review';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { SelectTown } from './SelectTown';
import { Inject, fromGlobalId } from '../../helpers';
import { AssignWorkService } from '../../service/assignWorkService';
import * as moment from 'moment';
import { RouteComponentProps } from 'react-router';
import { UserService } from '../../service/userService';
import { MdHome, MdArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';
import '../Common/listPageStyles';

export class AddAssignWork extends React.Component<Props, State> {
  @Inject assignWorkService: AssignWorkService;
  @Inject userService: UserService;

  constructor(props: Props) {
    super(props);

    this.state = {
      assignWork: {
        state: null,
        towns: [],
        areas: [],
        supervisor: null,
        caller: null,
        deadline: '',
        dateAssigned: moment().format('YYYY-MM-DD'),
      },
      view: currentView.STATE_AND_EMPLOYEE,
      selectedState: null,
      selectedEmployee: null,
      updateTownCount: 0,
      user: null,
      lockSubmit: false,
    };
  }

  // BUG-08: singleton BehaviorSubject, subscription leaked on every unmount.
  private userSub: { unsubscribe: () => void } = null;

  componentDidMount() {
    this.userSub = this.userService.user$.subscribe(
      (user) => this.setState({ user }),
    );
  }

  componentWillUnmount() {
    this.userSub && this.userSub.unsubscribe();
  }

  nextView = () => {
    this.setState({ lockSubmit: true });
    const { view, assignWork } = this.state;
    if (view === currentView.STATE_AND_EMPLOYEE) {
      if (!assignWork.state || !assignWork.caller) {
        this.setState({ lockSubmit: false });
        return notify({
          type: 'error',
          title: 'State or Caller has to be selected',
          duration: 3000,
        });
      }
      return this.setState({ view: currentView.TOWN, lockSubmit: false });
    }
    if (view === currentView.TOWN) {
      if (assignWork.towns.length !== 1) {
        this.setState({ lockSubmit: false });
        return notify({
          type: 'error',
          title: 'Select one Town',
          duration: 3000,
        });
      }
      return this.setState({ view: currentView.DEADLINE, lockSubmit: false });
    }
    if (view === currentView.DEADLINE) {
      this.submit();
    }
  }

  previousView = () => {
    const { view } = this.state;
    if (view === currentView.TOWN) {
      return this.setState({ view: currentView.STATE_AND_EMPLOYEE });
    }
    if (view === currentView.DEADLINE) {
      return this.setState({ view: currentView.TOWN });
    }
  }

  updateTownList = () => {
    this.setState({ updateTownCount: this.state.updateTownCount + 1 });
  }

  submit = () => {
    this.setState({ lockSubmit: true });
    const { assignWork } = this.state;
    const data: AssignWorkMutationInput = {
      caller: assignWork.caller.id,
      state: assignWork.state.id,
      towns: assignWork.towns.map((v) => fromGlobalId(v.id)),
      areas: assignWork.areas.map((v) => fromGlobalId(v.id)),
      supervisor: null,
      dateAssigned: assignWork.dateAssigned,
      deadline: assignWork.deadline,
    };
    this.assignWorkService.add(
      data,
      (response: { data: { createAssignwork: AssignWorkMutationPayload }, errors: any[] }) => {
        if (!response.data.createAssignwork && response.errors) {
          return notify({
            type: 'error',
            title: response.errors[0].message,
            duration: 3500,
            callBack: () => {
              this.setState({ lockSubmit: false });
            },
          });
        }
        const errors = response.data.createAssignwork.errors;
        if (!errors) {
          notify({
            type: 'success',
            title: 'Work Assigned',
            callBack: () => {
              this.setState({ lockSubmit: false });
              this.updateTownList();
              (this.props as any).history.push('/dashboard/assign_work');
            },
          });
        } else {
          notify({
            type: 'error',
            title: errors[0].field.toUpperCase(),
            message: errors[0].messages[0],
            callBack: () => {
              this.setState({ lockSubmit: false });
            },
            duration: 3500,
          });
        }
      },
      () => notify({
        title: 'Something went wrong',
        type: 'error',
      }),
    );
  }

  setSelectedState = (selectedState: StateNodeEdge) => {
    this.setState({ selectedState });
  }

  setSelectedEmployee = (selectedEmployee: UserDetailNodeEdge) => {
    this.setState({ selectedEmployee });
  }

  wizard = () => {
    const { view, assignWork } = this.state;

    switch (view) {
      case currentView.STATE_AND_EMPLOYEE: {
        return (
          <StateEmployeeSelection
            state={assignWork.state}
            employee={assignWork.caller}
            onStateChange={(state) => this.setState({ assignWork: { ...assignWork, state } })}
            onEmployeeChange={(emp) => this.setState({ assignWork: { ...assignWork, caller: emp } })}
            selectedState={this.state.selectedState}
            selectedEmployee={this.state.selectedEmployee}
            setSelectedState={this.setSelectedState}
            setSelectedEmployee={this.setSelectedEmployee}
          />
        );
      }
      case currentView.TOWN: {
        const retailerCountFromList: any[] = assignWork.areas.length ? assignWork.areas : assignWork.towns;
        const totalRetailers = retailerCountFromList.reduce((retailers, area) =>
          retailers + Number(area.retailerCount), 0,
        );
        // These four lines used to assign straight into this.state.assignWork
        // during render(). Mutating state in the render path is a React
        // correctness bug: the values are written on every render (including
        // renders triggered by unrelated state), never go through setState so
        // nothing re-renders in response, and -- because Dashboard's route
        // container previously remounted on every render -- the recomputed
        // dates could silently differ from what the Review panel had shown.
        // Compute locally and hand the derived values down as props instead.
        const today = moment().format('YYYY-MM-DD');
        const startDate = this.state.selectedEmployee.node.employee.startDateForNextWork;
        let dateAssigned = moment(today).isAfter(startDate) ? today : startDate;
        if (!assignWork.caller.employee.noOfWorksPending) {
          dateAssigned = today;
        }
        const deadline = moment(dateAssigned, 'YYYY-MM-DD')
          .add(Math.ceil(totalRetailers / 70) + 1, 'days').format('YYYY-MM-DD');
        // Persist once, out of the render pass, and only when it actually
        // changed -- otherwise this setState would loop.
        if (assignWork.dateAssigned !== dateAssigned || assignWork.deadline !== deadline) {
          setTimeout(
            () => this.setState((s) => ({
              assignWork: { ...s.assignWork, dateAssigned, deadline },
            })),
            0,
          );
        }
        return (
          <SelectTown
            state={assignWork.state}
            towns={assignWork.towns}
            areas={assignWork.areas}
            caller={assignWork.caller}
            onAreaSelect={(areas) => this.setState({ assignWork: { ...assignWork, areas } })}
            onTownSelect={(towns) => this.setState({ assignWork: { ...assignWork, towns } })}
            updateTownCount={this.state.updateTownCount}
          />
        );
      }
      case currentView.DEADLINE: {
        return (
          <>
            <Input
              type='date'
              label='Assigned Date'
              value={assignWork.dateAssigned}
              disabled
            />
            <Input
              type='date'
              label='Deadline'
              value={assignWork.deadline}
              onChange={(e) => this.setState({ assignWork: { ...assignWork, deadline: e.target.value } })}
            />
          </>
        );
      }
    }
  }

  // The card title was hardcoded to 'Select State and Employee', so it said
  // that on all three steps. Title, hint and the step indicator below are all
  // driven off the current view instead.
  static STEPS = [
    { view: currentView.STATE_AND_EMPLOYEE, label: 'State & Caller',
      title: 'Select State and Caller',
      hint: 'Choose the state to work in and the caller who will make the calls.' },
    { view: currentView.TOWN, label: 'Town & Areas',
      title: 'Select Town and Areas',
      hint: 'Pick exactly one town. Expand it to narrow the allocation to specific areas.' },
    { view: currentView.DEADLINE, label: 'Deadline',
      title: 'Confirm the Deadline',
      hint: 'The deadline is estimated from the retailer count. Adjust it if you need to.' },
  ];

  stepIndex = () => Math.max(0, AddAssignWork.STEPS.findIndex((s) => s.view === this.state.view))

  stepIndicator = () => {
    const active = this.stepIndex();
    return (
      <div className='cs-wiz__steps' role='list' aria-label='Assign work progress'>
        {AddAssignWork.STEPS.map((s, i) => (
          <React.Fragment key={s.label}>
            {i > 0 && <span className={`cs-wiz__bar${i <= active ? ' cs-wiz__bar--done' : ''}`} />}
            <span
              role='listitem'
              aria-current={i === active ? 'step' : undefined}
              className={
                'cs-wiz__step' +
                (i === active ? ' cs-wiz__step--active' : '') +
                (i < active ? ' cs-wiz__step--done' : '')
              }
            >
              <span className='cs-wiz__dot'>{i < active ? '✓' : i + 1}</span>
              <span className='cs-wiz__label'>{s.label}</span>
            </span>
          </React.Fragment>
        ))}
      </div>
    );
  }

  breadcrumbs = () => ({
    seperator: '/',
    paths: [
      { text: <MdHome />, link: '/dashboard' },
      { text: 'Assigned Work List', link: '/dashboard/assign_work' },
      { text: 'Assign Work', link: '/dashboard/assign_work/add' },
    ].map((v) => ({
      render: () => (
        <Link key={v.link} to={v.link}>
          {v.text}
        </Link>
      ),
    })),
  })

  render() {
    const { assignWork, view, user, lockSubmit } = this.state;
    return (
      <Loading
        isLoading={!user}
        render={() => (
          <div className='cs-wiz'>
          <Page
            title={'Assign Work'}
            breadcrumbs={this.breadcrumbs()}
            backIcon={
              <Link to={'/dashboard/assign_work'}>
                <MdArrowBack />
              </Link>
            }
          >
          {this.stepIndicator()}
          <Row>
            <Col span={16}>
              <div className='cs-wiz__card'>
              <Card
                title={AddAssignWork.STEPS[this.stepIndex()].title}
                style={{
                  body: {
                    // Only the town step has a long list worth reserving
                    // height for. A blanket min-height pushed the Next button
                    // below the fold on the two short steps -- the original
                    // fixed 70vh had the same fault.
                    minHeight: view === currentView.TOWN ? '52vh' : '0',
                    maxHeight: '68vh',
                    overflowY: 'auto',
                  },
                }}
                footer={
                  // ButtonGroup's props are {children} only -- it does not
                  // accept className -- so the class goes on a wrapper.
                  <div className='cs-wiz__actions'>
                  <ButtonGroup>
                    {/* Back used to render on step 1, where previousView is a
                        no-op -- a dead control. */}
                    {this.stepIndex() > 0 && (
                      <Button
                        style={{ margin: '5px', width: 'calc(50% - 10px)' }}
                        type='secondary'
                        onClick={this.previousView}
                      >
                        Back
                      </Button>
                    )}
                    <Button
                      style={{
                        margin: '5px',
                        width: this.stepIndex() > 0 ? 'calc(50% - 10px)' : 'calc(100% - 10px)',
                      }}
                      type='primary'
                      onClick={this.nextView}
                      disabled={lockSubmit}
                    >
                      {view === currentView.DEADLINE ? 'Submit' : 'Next'}
                    </Button>
                  </ButtonGroup>
                  </div>
                }
              >
                <p className='cs-wiz__hint'>{AddAssignWork.STEPS[this.stepIndex()].hint}</p>
                {this.wizard()}
              </Card>
              </div>
            </Col>
            <Col span={8}>
              <div className='cs-wiz__card'>
              <Card
                title='Review and Save'
              >
                <Review
                  caller={nestedAccess(assignWork.caller, 'employee')}
                  state={nestedAccess(assignWork.state, 'name')}
                  towns={assignWork.towns}
                  areas={assignWork.areas}
                  deadline={assignWork.deadline && assignWork.deadline}
                  dateAssigned={assignWork.dateAssigned}
                  userId={user && user.id}
                />
              </Card>
              </div>
            </Col>
          </Row>
          </Page>
          </div>
        )}
      />
    );
  }
}

interface State {
  assignWork: AssignWorkDetailedInput;
  view: currentView;
  selectedState: StateNodeEdge;
  selectedEmployee: UserDetailNodeEdge;
  updateTownCount: number;
  user: UserDetailNode;
  lockSubmit: boolean;
}

interface AssignWorkDetailedInput {
  state: StateNode;
  towns: TownNode[];
  areas: AreaNode[];
  supervisor: UserDetailNode;
  caller: UserDetailNode;
  deadline?: string;
  dateAssigned: string;
}

interface Props extends RouteComponentProps {
}
